import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

/**
 * @param {boolean} _
 * @param {import('modules/statistics/types').SetExportModalVisibilityAction} action
 * @returns {boolean}
 */
const setVisibility = (_, { payload }) => payload;

const hide = () => false;

export default createReducer(initialState, {
  [types.STATISTICS_DEALER_EXPORT_MODAL_VISIBILITY]: setVisibility,
  [types.STATISTICS_DEALER_EXPORT_SUCCESS]: hide,
});
